module.exports = __webpack_public_path__ + "img/d34aea464dd3278fe11ef9b8349c2bae.svg";